import Immutable from 'immutable';
import { officerList } from '../../data/officers';

const officers = (state = new Immutable.Map(), action) => {
  return state.merge(
    Immutable.fromJS(
      officerList.reduce((map, property) => {
        map[property.id] = property;
        return map;
      }, {})
    )
  );
};

export default officers;
